import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requirePrinter } from "/D/Projects/fancy-printer/dist/ts/printer.js";
var printerExports = requirePrinter();
export { printerExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(printerExports);